import { DataBean } from "../DataBean";

export class TaxHoldType extends DataBean {


    public async getTaxHoldTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxHoldTypeConstants_Number", [args]);
    }

}